import GridPowerBI from '../components/grid-powerbi'
import TopBarPowerBI from '../components/top-bar-powerbi'
import dataDesc from '../const/desc-powerbi'

const PowerBI = () => {
  return (
    <div className="powerbi">
      <TopBarPowerBI />
      {dataDesc.map((e) => {
        return (
          <div className="powerbi-module" key={e.label}>
            <h3>{e.label}</h3>
            <GridPowerBI data={e.data} />
          </div>
        )
      })}
    </div>
  )
}

export default PowerBI
